import { render, staticRenderFns } from "./CardApartment.vue?vue&type=template&id=8dc1684c&scoped=true&"
import script from "./CardApartment.vue?vue&type=script&lang=js&"
export * from "./CardApartment.vue?vue&type=script&lang=js&"
import style0 from "./CardApartment.vue?vue&type=style&index=0&id=8dc1684c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc1684c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8dc1684c')) {
      api.createRecord('8dc1684c', component.options)
    } else {
      api.reload('8dc1684c', component.options)
    }
    module.hot.accept("./CardApartment.vue?vue&type=template&id=8dc1684c&scoped=true&", function () {
      api.rerender('8dc1684c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/CardApartment.vue"
export default component.exports